import { render } from "./SingleTicketToBuy.vue?vue&type=template&id=dc538d9e&scoped=true"
import script from "./SingleTicketToBuy.vue?vue&type=script&lang=js"
export * from "./SingleTicketToBuy.vue?vue&type=script&lang=js"

import "./SingleTicketToBuy.vue?vue&type=style&index=0&id=dc538d9e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc538d9e"]])

export default __exports__